import { render } from "./TrafficSimulator.vue?vue&type=template&id=e16a0a66&scoped=true"
import script from "./TrafficSimulator.vue?vue&type=script&lang=js"
export * from "./TrafficSimulator.vue?vue&type=script&lang=js"

import "./TrafficSimulator.vue?vue&type=style&index=0&id=e16a0a66&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e16a0a66"]])

export default __exports__